import React from 'react'

import SMSInputContainer from 'src/containers/AutomaticPlan/PhoneVerification/PhoneVerificationContainer'

const SMSInputPage: React.FC = () => {
  return <SMSInputContainer />
}

export const PATH = '/phone-verification' as const
export default SMSInputPage
